/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PayrollViewerControllerListImports200ResponseDataInner { 
    id?: string;
    companyId?: string;
    period?: string;
    totvsBranchCode?: string;
    source?: PayrollViewerControllerListImports200ResponseDataInner.SourceEnum;
    fileName?: string;
    fileChecksum?: string;
    rowCount?: number;
    employeeCount?: number;
    weeks?: Array<number>;
    status?: PayrollViewerControllerListImports200ResponseDataInner.StatusEnum;
    importedAt?: string;
    notes?: string;
    createdBy?: number;
}
export namespace PayrollViewerControllerListImports200ResponseDataInner {
    export type SourceEnum = 'excel' | 'totvs_api';
    export const SourceEnum = {
        Excel: 'excel' as SourceEnum,
        TotvsApi: 'totvs_api' as SourceEnum
    };
    export type StatusEnum = 'pending' | 'active' | 'superseded' | 'failed';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Active: 'active' as StatusEnum,
        Superseded: 'superseded' as StatusEnum,
        Failed: 'failed' as StatusEnum
    };
}


